import type { TFunction } from 'i18next'

import { defaultRuleFactory } from '../rules/default-rules.ts'
import { createErrorMap } from '../utils/create-error-map.ts'
import type { ErrorMapWithContext } from '../utils/types.ts'

export const defaultRuleMapFactory = (
  t: TFunction<'validation'>
): ErrorMapWithContext => {
  return createErrorMap(t, defaultRuleFactory)
}
